const ROOT = Symbol("root");
const LISTENERS = Symbol("events");
const NAMESPACE = Symbol("namespace");

/**
 * Provides an access to an event namespace.
 */
class Bus {

}

module.exports = Bus;
